// Theme registry. Mirrors corefi-bank/src/styles/themes/index.ts.
// Adding a new style:
//   1. Create src/styles/themes/<name>/{light.css,dark.css}
//   2. Add `@import './themes/<name>/light.css';` and `@import './themes/<name>/dark.css';`
//      to src/styles/globals.css (so Vite emits the rules).
//   3. Register the theme key here.

export const THEME_REGISTRY = {
  default: { label: 'Fluentix Default' },
} as const;

export type ThemeKey = keyof typeof THEME_REGISTRY;

export const DEFAULT_THEME: ThemeKey = 'default';

export const THEME_KEYS = Object.keys(THEME_REGISTRY) as ThemeKey[];
